import styled from 'styled-components';
import {theme} from '@styles/theme';

export const CoverageBlockWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CoverageBlockTopWrapper = styled.div<{chartWidth: string}>`
  width: ${({chartWidth}) => (chartWidth ? chartWidth : '100%')};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CoverageBlockTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CoverageTestsBlockToggle = styled.div`
  cursor: pointer;
`;

export const CoverageWrapper = styled.div<{forTable: boolean; chartWidth: string}>`
  width: ${({chartWidth}) => (chartWidth ? chartWidth : '100%')};
  height: ${({forTable}) => (forTable ? '4px' : '8px')};
  display: flex;
  gap: 2px;
`;

export const CoverageAutoWrapper = styled.div<{width: number}>`
  position: relative;
  display: ${({width}) => (width > 0 ? 'block' : 'none')};
  width: ${({width}) => (width > 0 ? width + '%' : '0%')};
  height: 100%;
  background-color: ${theme.colors.auto00};
  border-top-left-radius: ${theme.roundedSmall};
  border-bottom-left-radius: ${theme.roundedSmall};
  border-top-right-radius: ${({width}) => (width == 100 ? theme.roundedSmall : '0px')};
  border-bottom-right-radius: ${({width}) => (width == 100 ? theme.roundedSmall : '0px')};
`;

export const CoverageManualWrapper = styled.div<{
  width: number;
  emptyWidth: number;
  autoWidth: number;
}>`
  position: relative;
  display: ${({width}) => (width > 0 ? 'block' : 'none')};
  width: ${({width}) => (width > 0 ? width + '%' : '0%')};
  height: 100%;
  background-color: ${theme.colors.manual00};
  border-top-left-radius: ${({width, autoWidth}) =>
    width == 100 || autoWidth == 0 ? theme.roundedSmall : '0px'};
  border-bottom-left-radius: ${({width, autoWidth}) =>
    width == 100 || autoWidth == 0 ? theme.roundedSmall : '0px'};
  border-top-right-radius: ${({width, emptyWidth}) =>
    width == 100 || emptyWidth == 0 ? theme.roundedSmall : '0px'};
  border-bottom-right-radius: ${({width, emptyWidth}) =>
    width == 100 || emptyWidth == 0 ? theme.roundedSmall : '0px'};
`;

export const CoverageEmptyWrapper = styled.div<{width: number}>`
  position: relative;
  display: ${({width}) => (width === 0 ? 'none' : 'block')};
  width: ${({width}) => (width ? width + '%' : '100%')};
  height: 100%;
  background-color: ${theme.colors.basic05};
  border-top-left-radius: ${({width}) => (width == 100 ? theme.roundedSmall : '0px')};
  border-bottom-left-radius: ${({width}) => (width == 100 ? theme.roundedSmall : '0px')};
  border-top-right-radius: ${theme.roundedSmall};
  border-bottom-right-radius: ${theme.roundedSmall};
`;

export const CoverageTestsBlock = styled.div<{show: boolean}>`
  margin-top: 12px;
  width: 100%;
  display: ${({show}) => (show ? 'flex' : 'none')};
  gap: 16px;
  flex-wrap: wrap;
`;
